import { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { useAppDispatch } from 'src/store/hooks';
import { Button } from 'src/components/reusable/Buttons';
import { storageRemove } from 'src/utils';
import { Paragraph } from 'src/components/reusable/Typography';
import CloseButton from 'src/components/reusable/Buttons/components/CloseButton';

interface LogoutModalProps {
  isOpen: boolean;
  closeModal: () => void;
  userData: any;
}

const LogoutModal = ({ isOpen, closeModal, userData }: LogoutModalProps) => {
  const handleLogout = () => {
    storageRemove('token');
    window.location.pathname = '/';
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={closeModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="relative flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="relaive w-full max-w-lg transform rounded-lg bg-white p-6 align-middle shadow-xl transition-all text-center">
                <div className="z-50 absolute right-0 -top-14">
                  <CloseButton
                    onClick={closeModal}
                    className="bg-white"
                    iconClassName="text-body-primary"
                  />
                </div>
                <Dialog.Title
                  as="h3"
                  className="text-lg font-bold leading-6 text-gray-800"
                >
                  Log out
                </Dialog.Title>
                <div className="mt-6">
                  <Paragraph className="text-sm text-gray-800">
                    You are about to log out of your account,{' '}
                    <span className="font-bold">{userData.email}</span>
                  </Paragraph>
                </div>

                <div className="mt-16 flex flex-col xxs:flex-row items-center justify-center gap-y-5 xxs:gap-x-8 w-full">
                  <Button
                    type="button"
                    className="bg-[#F9FAFA] text-[#7B828E] w-full"
                    onClick={closeModal}
                    variant="light"
                  >
                    Cancel
                  </Button>
                  <Button
                    type="button"
                    className="w-full"
                    onClick={handleLogout}
                    variant="error"
                  >
                    Yes, logout
                  </Button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default LogoutModal;
